"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDynamicDropdownHeight = void 0;
const react_1 = __importDefault(require("react"));
const getHTMLElementHeight = (element) => {
    if (!element) {
        return 0;
    }
    const rect = element.getBoundingClientRect();
    const computedStyle = getComputedStyle(element);
    const marginTop = parseFloat(computedStyle.marginTop) || 0;
    const marginBottom = parseFloat(computedStyle.marginBottom) || 0;
    return rect.height + marginTop + marginBottom;
};
function useDynamicDropdownHeight({ dropdownOptions, dropdownRef, optionDisplayCount, showNoResults }) {
    const hasScroll = !!optionDisplayCount && dropdownOptions.length > optionDisplayCount;
    // Use optionDisplayCount to restrict the height of the dropdown.
    // If the number of options exceeds optionDisplayCount, the dropdown
    // will have a scrollbar.
    react_1.default.useEffect(() => {
        if (!dropdownRef.current) {
            return;
        }
        if (!optionDisplayCount || dropdownOptions.length === 0 || showNoResults) {
            dropdownRef.current.style.setProperty("max-height", null);
            return;
        }
        const firstOption = dropdownRef.current.querySelector("li:first-of-type");
        const firstOptionHeight = firstOption
            ? getHTMLElementHeight(firstOption)
            : 0;
        const lastOption = dropdownRef.current.querySelector("li:last-of-type");
        const lastOptionHeight = lastOption ? getHTMLElementHeight(lastOption) : 0;
        const option = dropdownRef.current.querySelector("li:not(:first-of-type):not(:last-of-type)");
        const optionHeight = option ? getHTMLElementHeight(option) : 0;
        const displayCount = Math.min(dropdownOptions.length, optionDisplayCount);
        let dropdownHeight = 0;
        if (displayCount === 1) {
            dropdownHeight = firstOptionHeight;
        }
        else {
            const totalOptionHeight = optionHeight * (optionDisplayCount - 2); // excluding first and last option
            dropdownHeight = firstOptionHeight + lastOptionHeight + totalOptionHeight;
        }
        dropdownRef.current.style.setProperty("max-height", `${dropdownHeight}px`);
    }, [dropdownRef, optionDisplayCount, dropdownOptions, showNoResults]);
    const handleScroll = react_1.default.useCallback(() => {
        if (!dropdownRef.current) {
            return;
        }
    }, [dropdownRef]);
    // For the initial render, check if the dropdown has overflow
    // and show bottom overlay if needed
    react_1.default.useEffect(() => {
        handleScroll();
    }, [handleScroll]);
    return { handleScroll, hasScroll };
}
exports.useDynamicDropdownHeight = useDynamicDropdownHeight;
//# sourceMappingURL=useDynamicDropdownHeight.js.map